import { render, staticRenderFns } from "./SalesPromoSupplierGroupProduct.vue?vue&type=template&id=ba72b86c&"
import script from "./SalesPromoSupplierGroupProduct.vue?vue&type=script&lang=js&"
export * from "./SalesPromoSupplierGroupProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports